var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSignup(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 672,
    height: 896,
    viewBox: "0 0 672 896",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#signup_svg__clip0_3668_65163)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0c61.866 0 112 50.153 112 112 0 61.866-50.153 112-112 112V0zM224 224c-61.866 0-112-50.153-112-112C112 50.134 162.153 0 224 0v224z",
    fill: "#FD8F52"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M224 0H.033C61.883.018 112 50.164 112 112c0 61.866-50.153 112-112 112h224c-61.866 0-112-50.153-112-112C112 50.134 162.153 0 224 0z",
    fill: "#C7DAFF"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FD8F52",
    d: "M224 0h224v224H224zM448 0c61.866 0 112 50.153 112 112 0 61.866-50.153 112-112 112V0zM560 0c61.866 0 112 50.153 112 112 0 61.866-50.153 112-112 112V0z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M448 0h.033H448zm112 112C560 50.164 509.884.018 448.033 0H560v112zM448 224h112V112c0 61.866-50.153 112-112 112zM560 0h.033H560zm112 112C672 50.164 621.884.018 560.033 0H672v112zM560 224h112V112c0 61.866-50.153 112-112 112z",
    fill: "#105ED5"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFE6D9",
    d: "M0 224h224v224H0zM224 224v224h224c0-123.694-100.269-224-224-224z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M448 224H224c123.731 0 224 100.306 224 224V224z",
    fill: "#105ED5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M560 224H448v112c61.847 0 112-50.134 112-112zM672 336V224H560c0 61.847 50.134 112 112 112zM448 336v112h112c0-61.847-50.134-112-112-112zM560 448h112V336c-61.847 0-112 50.134-112 112z",
    fill: "#105ED5"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M672 336c-61.866 0-112-50.153-112-112 0 61.866-50.153 112-112 112 61.866 0 112 50.153 112 112 0-61.866 50.153-112 112-112z",
    fill: "#FFE6D9"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FD8F52",
    d: "M0 448h224v224H0zM224 448v224h224c0-123.694-100.269-224-224-224z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M448 448H224c123.731 0 224 100.306 224 224V448z",
    fill: "#C7DAFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M560 448H448v112c61.847 0 112-50.134 112-112zM672 560V448H560c0 61.847 50.134 112 112 112zM448 560v112h112c0-61.847-50.134-112-112-112zM560 672h112V560c-61.847 0-112 50.134-112 112z",
    fill: "#FFE6D9"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M672 560c-61.866 0-112-50.153-112-112 0 61.866-50.153 112-112 112 61.866 0 112 50.153 112 112 0-61.866 50.153-112 112-112z",
    fill: "#FD8F52"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112 784h112V672c-61.847 0-112 50.134-112 112zM112 896h112V784c-61.847 0-112 50.134-112 112zM0 784h112V672C50.153 672 0 722.134 0 784zM0 896h112V784C50.153 784 0 834.134 0 896z",
    fill: "#105ED5"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M112 784h112c-61.847 0-112 50.134-112 112V784zM0 896c0-61.866 50.153-112 112-112 0-61.866 50.153-112 112-112H0v224zm112-224v112H0c0-61.866 50.153-112 112-112z",
    fill: "#C7DAFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224 896h224V672c-123.694 0-224 100.269-224 224z",
    fill: "#105ED5"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M448 672H224v224c0-123.731 100.306-224 224-224z",
    fill: "#C7DAFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M672 672c0 61.866-50.153 112-112 112-61.866 0-112-50.153-112-112h224zM448 896c0-61.866 50.153-112 112-112 61.866 0 112 50.153 112 112H448z",
    fill: "#FFE6D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M672 672.059C671.968 733.897 621.827 784 560 784c-61.854 0-111.981-50.134-112-111.965V896c0-61.866 50.153-112 112-112 61.866 0 112 50.153 112 112V672.059z",
    fill: "#105ED5"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "signup_svg__clip0_3668_65163"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 672,
    height: 896,
    rx: 32,
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSignup);
export default __webpack_public_path__ + "static/media/signup.998abd69ce26f77bd6b68bb0e6800479.svg";
export { ForwardRef as ReactComponent };